import React, { useState } from "react";
import { withTranslation } from 'react-i18next';
import { compose } from "redux";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import { Row, Col, Modal, Button, Icon, TextInput } from "react-materialize";
import ButtonFactory from "../../../components/material/ButtonFactory";
import { useForm } from "react-hook-form";

function PalletConfigurationForm(props) {
    const { t, item, formLists } = props;
    const [error, setError] = useState({});

    const { register, handleSubmit, formState: { errors } } = useForm(
    { defaultValues: {
        affectedCm: item.affectedCm,
        expeditionType: item.expeditionType,
        totalUnits: item.totalUnits,
        unitsPerMasterpack: item.unitsPerMasterpack
        }
    });

    function onClose() {
        props.onClose();
    }

    function onSubmit(data) {
       
        const palletConfiguration = {
            index: item.index, //If -1 will be considered new in the main form, if not edit correct index on the other side
            affectedCm: data.affectedCm,
            expeditionType: data.expeditionType,
            totalUnits: data.totalUnits,
            unitsPerMasterpack: data.unitsPerMasterpack
        }

        props.onSave(palletConfiguration);
        onClose();
    }

    return (
    <Dialog open={props.isOpen} onClose={props.onClose} disableEnforceFocus>
        <DialogTitle>{t('pallet_configuration.new_pallet_configuration')}</DialogTitle>
        <DialogContent>
            <form name="palletconfigurationForm" id="palletconfigurationForm" onSubmit={handleSubmit(onSubmit)}>
                <Row>
                    <Col m={12} s={12}>
                        <label className="active" htmlFor="affectedCm" style={{ width: "300px", display: "inline-block" }} >{t('pallet_configuration.affected_cm')}</label>
                        <select {...register('affectedCm',  { required: "Required"})}>
                            {formLists.cmList.map((cm, index) =>{
                                return (<option key={index} value={cm.netsuiteInternalId}>{cm.name}</option>)
                            })}
                        </select>
                        {errors.affectedCm && <p className="red-text" >{errors.affectedCm.message}</p>}
                    </Col>
                    </Row>
                    <Row>
                    <Col m={12} s={12}>
                        <label className="active" htmlFor="expeditionType" style={{ width: "300px", display: "inline-block" }} >{t('pallet_configuration.expedition_type')}</label>
                        <select {...register('expeditionType',  { required: "Required"})}>
                            {formLists.expeditionType.map((cm, index) =>{
                                return (<option key={index} value={cm.name}>{cm.name}</option>)
                            })}
                        </select>
                        {errors.expeditionType && <p className="red-text" >{errors.expeditionType.message}</p>}
                    </Col>
                    </Row>
                    <Row>
                        <Col m={12} s={12}>
                            <label className="active" htmlFor="totalUnits" style={{ width: "300px", display: "inline-block" }} >{t('pallet_configuration.total_units')}</label>
                            <input type="number" name="totalUnits"  {...register('totalUnits',  { required: "Required"})} className=" left-align "/>
                            {errors.totalUnits && <p className="red-text" >{errors.totalUnits.message}</p>}
                        </Col>
                    </Row>
                <Row>
                    <Col m={12} s={12}>
                        <label className="active" htmlFor="unitsPerMasterpack" style={{ width: "300px", display: "inline-block" }} >{t('pallet_configuration.units_by_masterpack')}</label>
                        <input type="number" name="unitsPerMasterpack"  {...register('unitsPerMasterpack',  { required: "Required"})} className=" left-align "/>
                        {errors.unitsPerMasterpack && <p className="red-text" >{errors.unitsPerMasterpack.message}</p>}
                    </Col>
                </Row>
                <Row>
                    <Col s={12}>
                            {t("pallet_configuration.twin_disclaimer")}
                    </Col>
                </Row>
            </form>
        </DialogContent>
        <DialogActions>
          <ButtonFactory onClick={handleSubmit(onSubmit)}  color="primary" text={"Save"} />
          <ButtonFactory onClick={onClose} color="primary" text={"Cancel"} />
        </DialogActions>
    </Dialog>)
}


PalletConfigurationForm.propTypes = {
  auth: PropTypes.object.isRequired,
};
const mapStateToProps = state => ({
  auth: state.auth,
});

export default compose(
  withTranslation(),
  connect(
    mapStateToProps,
  )
)(PalletConfigurationForm);